const priceFinderLink =
  'https://www.pricefinder.com.au/portal/app?page=ExternalLogin&service=page';

export default priceFinderLink;
